import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Onboarding from '../onboarding/Onboarding';
import { AnimatePresence } from 'framer-motion';
import { motion } from 'framer-motion';
import { scaleMotionProps } from 'constants/animationProps';
import Loader from 'wrapper/loader';
import ResponsiveLayout from 'components/ResponsiveLayout';

//this is the second main layout component that wraps the entire web app

export const AppShell = ({
  logout,
  isOnboarding,
  user,
  setIsOnboarding,
  data,
}) => {
  const location = useLocation();
  const isStandaloneOnboard = location.pathname === '/onboard';

  if (isStandaloneOnboard) {
    return data ? (
      <AnimatePresence>
        <motion.div {...scaleMotionProps}>
          <Outlet />
        </motion.div>
      </AnimatePresence>
    ) : (
      <Loader variant="colorful" FullScreen={true} />
    );
  }

  // Add event listener for beforeunload event
  // window.addEventListener('beforeunload', async (event) => {
  //   await logout({ logoutParams: { returnTo: window.location.origin } });

  // });
  // Rely on the parent Login component's authentication check (isAuthenticated + data)
  // and avoid calling CheckAuth here. This ensures the shell and chatbot render
  // whenever Login has verified the session with the backend.
  return !isOnboarding && data ? (
    <AnimatePresence>
      <motion.div {...scaleMotionProps}>
        <ResponsiveLayout>
          <Outlet />
        </ResponsiveLayout>
      </motion.div>
    </AnimatePresence>
  ) : data ? (
    <Onboarding setIsOnboarding={setIsOnboarding} />
  ) : (
    <Loader variant="colorful" FullScreen={true} />
  );
};
